import { t } from "@lingui/macro";

import { SelectableTile } from "@whoosh/design-system/src/components/controls";
import { DropdownSelect } from "@whoosh/design-system/src/components/controls";
import {
  HStack,
  VStack,
  Text,
  Box,
} from "@whoosh/design-system/src/components/primitive";

export type GroupSizeControlBaseProps = {
  capacity: number;
  usedCapacity: number;
  currentGroupSize: number;
  setGroupSize: (size: number) => void;
};

// Base component with shared UI logic
export const GroupSizeControlBase = ({
  capacity,
  usedCapacity,
  currentGroupSize,
  setGroupSize,
}: GroupSizeControlBaseProps) => {
  const availableCapacity = capacity - usedCapacity;

  const arrayOptions =
    availableCapacity > 0 ? [...Array(availableCapacity)] : [];
  const selectOptions = arrayOptions.map((option, index) => ({
    value: index + 1,
    label: `${index + 1} ${index + 1 === 1 ? `${t`Player`}` : `${t`Players`}`}`,
  }));

  if (availableCapacity <= 1) {
    return null;
  }

  return (
    <VStack
      testID="group-size-control-section"
      gap={4}
      padding={5}
      paddingBottom={3}
      width="100%"
      backgroundColor="surface-primary"
    >
      <Text variant="mainBaseSemiBold">{t`Group Size`}</Text>
      <HStack gap={2} width="100%">
        {selectOptions.length > 4 ? (
          <Box width="100%">
            <DropdownSelect
              value={currentGroupSize}
              placeholder={t`Select Group Size`}
              testID="dropdown-select"
              onChange={(value) => {
                if (value) {
                  setGroupSize(value);
                }
              }}
              options={selectOptions}
              hideOuterMargin
            />
          </Box>
        ) : (
          arrayOptions.map((_, index) => (
            <SelectableTile
              testID={`group-size-${index + 1}`}
              isSmall
              key={index}
              align="center"
              isSelected={index + 1 === currentGroupSize}
              setSelected={(isSelected: boolean) => {
                if (isSelected) {
                  setGroupSize(index + 1);
                }
              }}
              title={`${index + 1}`}
            />
          ))
        )}
      </HStack>
    </VStack>
  );
};
